/* eslint max-len:0 */
import React from 'react'
import { Helmet } from 'react-helmet'
import { ToastContainer } from 'react-toastify'

import { ErrorBoundary } from '@duplo/utils/lib/errorTracking'

import 'react-toastify/dist/ReactToastify.min.css'

const TemplateWrapper = ({ categoryId, children }) => {
	if (!(typeof window !== 'undefined')) return null

	const templateContents = (
		<>
			<Helmet>
				<script type="text/javascript">
					{`(function()  { var field = 'xxTrustedFormCertUrl'; var provideReferrer = false; var invertFieldSensitivity = false; var useTaggedConsent = true; var tf = document.createElement('script'); tf.type = 'text/javascript'; tf.async = true; tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') + '://cfptwebapi.cfdomains.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + '&field=' + escape(field) + "&use_tagged_consent=" + useTaggedConsent + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s); } )();`}
				</script>
				<noscript>{`<img src="https://cfptwebapi.cfdomains.com/ns.gif" alt="ns.gif" />`}</noscript>
			</Helmet>
			<div>
				<ToastContainer />
				{children}
			</div>
		</>
	)

	// if we're in the client and can render the error boundry wrap everything in it.
	if (ErrorBoundary) {
		return <ErrorBoundary>{templateContents}</ErrorBoundary>
	}

	return templateContents
}

export default TemplateWrapper
